/** @type {import('tailwindcss').Config} */
import config from '../common/tailwind-preset.js';

export default {
  presets: [config],
  content: ['./index.html', './src/**/*.{js,ts,jsx,tsx}'],
  theme: {
    extend: {
      colors: {
        primary: {
          '010': '#F3F7FF',
          '020': '#E6F0FF',
          '030': '#C9DEFF',
          '040': '#A5C2FF',
          '050': '#7DA6FF',
          '060': '#4D6FFF',
          '070': '#2C4FB3',
          '080': '#1A3C8C',
          '090': '#0E265C',
        },
        sure: {
          '010': '#FFF9EF',
          '020': '#FCE4B8',
          '030': '#FCDA97',
          '040': '#FDCB6A',
          '050': '#FEBD3E',
          '060': '#FEB32B',
          '070': '#FEA918',
          '080': '#FF9F05',
          '090': '#FF9900',
        },
      },
      fontSize: {
        header1: ['28px', { lineHeight: '36px', fontWeight: 800 }],
        header2: ['24px', { lineHeight: '32px', fontWeight: 700 }],
        sub1: ['20px', { lineHeight: '28px', fontWeight: 700 }],
        sub2: ['18px', { lineHeight: '24px', fontWeight: 600 }],
        sub3: ['16px', { lineHeight: '24px', fontWeight: 600 }],
        sub35: ['14px', { lineHeight: '20px', fontWeight: 400 }],
        sub4: ['14px', { lineHeight: '20px', fontWeight: 600 }],
        sub5: ['12px', { lineHeight: '18px', fontWeight: 600 }],
        body1: ['16px', { lineHeight: '24px', fontWeight: 500 }],
        body2: ['14px', { lineHeight: '20px', fontWeight: 500 }],
        caption1: ['12px', { lineHeight: '18px', fontWeight: 400 }],
        caption2: ['10px', { lineHeight: '14px', fontWeight: 400 }],
      },
      fontFamily: {
        uber: ['Uber Move Text', 'sans-serif'],
      },
    },
  },
  plugins: [],
};
